import { render, staticRenderFns } from "./lecture-list-item.vue?vue&type=template&id=2348ffe9&scoped=true"
import script from "./lecture-list-item.vue?vue&type=script&lang=js"
export * from "./lecture-list-item.vue?vue&type=script&lang=js"
import style0 from "./lecture-list-item.vue?vue&type=style&index=0&id=2348ffe9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2348ffe9",
  null
  
)

export default component.exports